import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";
import {Product} from "../../../../store/state/order.state";
import {distinctUntilChanged, filter, map} from "rxjs/operators";
import {OrderActions} from "../../../../store/actions/order.actions";
import {UmbrellaValidators} from "../../../../umbrella-common/validation/umbrella-validators";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";
import {CLIENT_COUNTRY_CONFIGS} from "../../../../configuration/configs/client-country-configs";
import {orderSelector} from "../../../../store/state/state.selectors";

@Injectable()
export class PartTimeEmployeesHandler extends BaseFormControlHandler {

	showPartTimeEmployees: boolean;

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
		this.store.select(orderSelector)
			.pipe(
				filter(order => order.clientCountry != null),
				map(order => CLIENT_COUNTRY_CONFIGS[order.clientCountry]),
				map(config => config.order.showPartTimeEmployees)
			).subscribe(show => this.showPartTimeEmployees = show);

	}

	buildControls(form: FormGroup, product: Product) {
		form.addControl(`partTimeEmployeesIncluded${(product.standard.name)}`, this.fb.control(product.partTimeOrTempEmployeesIncluded == null ? null : product.partTimeOrTempEmployeesIncluded, UmbrellaValidators.radiobuttonRequired()));
		this.addSubscription(product.standard.name, form.controls['partTimeEmployeesIncluded' + product.standard.name].valueChanges.pipe(distinctUntilChanged()).subscribe(included => {
			this.store.dispatch(OrderActions.SET_PART_TIME_EMPLOYEES_INCLUDED({standardName: product.standard.name, included}));
			if (included) {
				this.addEmployeesCountDescription(form, product);
			} else {
				this.removeControlIfPresent(form, product.standard.name, 'employeesCountDescription');
			}
		}));

		product.partTimeOrTempEmployeesIncluded && this.addEmployeesCountDescription(form, product);
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		product.partTimeOrTempEmployeesIncluded = formService.getValueFor('partTimeEmployeesIncluded', srcForm);
		product.employeesCountDescription = formService.getValueOrNull(srcForm, 'employeesCountDescription');
	}

	private addEmployeesCountDescription(form: FormGroup, product: Product) {
		const control = this.fb.control(product.employeesCountDescription, [Validators.required, UmbrellaValidators.textLengthBetween(1, 5000)]);
		form.addControl('employeesCountDescription' + product.standard.name, control);
		this.addSubscription(product.standard.name, control.valueChanges.pipe(distinctUntilChanged()).subscribe(description => {
			this.store.dispatch(OrderActions.SET_EMPLOYEES_COUNT_DESCRIPTION({standardName: product.standard.name, description}));
		}));
	}

	override shouldApply(): boolean {
		return this.showPartTimeEmployees;
	}
}
